/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback, useContext, useEffect, useState, useRef } from "react";
import "./styles.css";
import "../../../../../src/datepicker-custom.css";
import DatePicker from "react-datepicker";
import { ptBR } from "date-fns/locale";
import { format } from "date-fns";
import { Context } from "../../../../hooks/useAuthContext";
import api from "../../../../services/axiosConfig";
import axios from "axios";
import { Alert, Button, Table } from "reactstrap";
import { formatarMoeda, formatarMoedaDolar } from "../../../../utils/formatMoeda";
import ModalLinks from "./components/ModalLinks/ModalLinks";
import ModalChavesPix from "../../../../components/ModalChavesPix/ModalChavesPix";
import Swal from "sweetalert2";
import { DateRange } from "react-date-range";
import { FaRegCalendarAlt } from "react-icons/fa";
import Pendente from "./components/Notifications/Pendente";
import { Link, useNavigate } from "react-router-dom";
import ComunicadoAlerta from "../../../../components/ComunicadoAlerta/ComunicadoAlerta";
import { IoIosInformationCircleOutline } from "react-icons/io";
import ModalRedesSociais from "../../../../components/ModalRedesSociais/ModalRedesSociais";
import { toast } from "react-toastify";
import AlertModal from "../../../../components/AlertModal/AlertModal";

function UserDashboard() {
  const {
    userData,
    exibirLogs,
    buscarNotasFiscaisPorMes,
    logout,
    atualizarDadosUsuario,
  } = useContext(Context);
  const navigate = useNavigate();

  const [alertaPendente, setAlertaPendente] = useState(null);
  const [alertaRecusado, setAlertaRecusado] = useState(false);
  const [isAlertModalOpen, setIsAlertModalOpen] = useState(false);

  // ... (restante dos estados não precisa de alteração) ...
  const userUtm = userData?.codeUtm;
  const minhasUtms = userData?.utms;
  const CACHE_KEY = "consultaUpload";
  const CACHE_DURATION_MS = 5 * 60 * 1000;
  const primeiroDiaDoMes = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
  const diaAtual = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 23, 59, 59, 999);
  const [selectedStartDate, setSelectedStartDate] = useState(primeiroDiaDoMes);
  const [selectedEndDate, setSelectedEndDate] = useState(diaAtual);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [receiptData, setReceiptData] = useState({});
  const [receiptDataPeriod, setReceiptDataPeriod] = useState({});
  const [receiptDataPeriodTable, setReceiptDataPeriodTable] = useState({});
  const [convertedValueYesterday, setConvertedValueYesterday] = useState(0);
  const [convertedValuePeriod, setConvertedValuePeriod] = useState(0);
  const [convertedValueLiquid, setConvertedValueLiquid] = useState(0);
  const [dolarCotation, setDolarContation] = useState(0);
  const [selectedDatePeriod, setSelectedDatePeriod] = useState(new Date());
  const mesAtual = format(selectedDatePeriod, "MMMM", { locale: ptBR });
  const [codeUtm, setCodeUtm] = useState(userUtm);
  const [perfil, setPerfil] = useState("");
  const [, setIsMobile] = useState(window.innerWidth < 768);
  const [modalAberto, setModalAberto] = useState(false);
  const [modalChavePixAberto, setModalChavePixAberto] = useState(false);
  const [modalRedesSociaisAberto, setModalRedesSociaisAberto] = useState(false);
  const [mostrarComunicado, setMostrarComunicado] = useState(false);
  const [mostrarCalendario, setMostrarCalendario] = useState(false);
  const [totalConverted, setTotalConverted] = useState(0);
  const [dataInfo, setDataInfo] = useState(null);
  const [notas, setNotas] = useState(null);
  const [periodTable, setPeriodTable] = useState([{ startDate: selectedStartDate, endDate: selectedEndDate, key: "selection", color: "#3d91ff" }]);
  const [canDisplayFiscalAlerts, setCanDisplayFiscalAlerts] = useState(true);
  const alertShownRef = useRef(false);

  const handleUserResponseToAlert = useCallback(async (accepted) => {
      if (!alertaPendente) return;
      try {
        await api.post(`/alerta/${alertaPendente._id}/respond`, {
          userId: userData._id,
          accepted: accepted,
        });

        if (accepted) {
          setIsAlertModalOpen(false);
          setAlertaPendente(null);
          setAlertaRecusado(false);
          atualizarDadosUsuario();
        } else {
          setAlertaRecusado(true);
        }
      } catch (error) {
        console.error("Erro ao responder ao alerta:", error);
        toast.error("Não foi possível salvar sua resposta.");
        setIsAlertModalOpen(false);
      }
    }, [alertaPendente, userData._id, atualizarDadosUsuario]
  );
  
  // --- useEffect DE BUSCA CORRIGIDO ---
  useEffect(() => {
    const fetchAlertaPendente = async () => {
      if (!userData?._id) return;
      try {
        const response = await api.get(`/alerta/latest?userId=${userData._id}`);
        if (response.data) {
          setAlertaPendente(response.data);
          // Se o backend nos informar que já foi recusado, atualizamos o estado.
          if (response.data.foiRecusado) {
            setAlertaRecusado(true);
          }
        }
      } catch (error) {
        console.error("Erro ao buscar alerta pendente:", error);
      }
    };
    fetchAlertaPendente();
  }, [userData?._id]);

  useEffect(() => {
    if (alertaPendente) {
      setIsAlertModalOpen(true);
    }
  }, [alertaPendente]);
  
  // ... (o restante do seu ficheiro UserDashboard.js permanece o mesmo)
  const dataSelecionada = new Date(selectedDate);
  const formattedDate = dataSelecionada.toLocaleDateString("pt-br").replace(/\//g, "-");
  const pad = (num) => num.toString().padStart(2, "0");
  const ajustarDataInicioUTC = (date) => new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), 0, 0, 0));
  const diaInicioTable = pad(ajustarDataInicioUTC(selectedStartDate).getUTCDate());
  const mesInicioTable = pad(ajustarDataInicioUTC(selectedStartDate).getUTCMonth() + 1);
  const anoInicioTable = ajustarDataInicioUTC(selectedStartDate).getUTCFullYear();
  const ajustarDataFimUTC = (date) => new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), 23, 59, 59));
  const diaFimTable = pad(ajustarDataFimUTC(selectedEndDate).getUTCDate());
  const mesFimTable = pad(ajustarDataFimUTC(selectedEndDate).getUTCMonth() + 1);
  const anoFimTable = ajustarDataFimUTC(selectedEndDate).getUTCFullYear();
  const dataInicioFormatadaTable = `${diaInicioTable}-${mesInicioTable}-${anoInicioTable}`;
  const dataFimFormatadaTable = `${diaFimTable}-${mesFimTable}-${anoFimTable}`;
  const getDolarCotation = async (receita) => { const tokenDolarAPI = import.meta.env.VITE_TOKEN_DOLAR_API; const url = `https://economia.awesomeapi.com.br/json/last/USD-BRL?token=${tokenDolarAPI}`; try { const { data } = await axios.get(url); const cotation = data?.USDBRL.bid; setDolarContation(Number(cotation)); return formatarMoeda(Number(receita * cotation)) || "API ERROR"; } catch (error) { exibirLogs && console.error("Erro ao buscar cotação do dólar: ", error); setDolarContation(0); return formatarMoeda(0.0); } };
  const firstDay = new Date(Date.UTC(selectedDatePeriod.getUTCFullYear(), selectedDatePeriod.getUTCMonth(), 1, 0, 0, 0));
  const lastDay = new Date(Date.UTC(selectedDatePeriod.getUTCFullYear(), selectedDatePeriod.getUTCMonth() + 1, 0, 23, 59, 59));
  const diaInicio = pad(firstDay.getUTCDate());
  const mesInicio = pad(firstDay.getUTCMonth() + 1);
  const anoInicio = firstDay.getUTCFullYear();
  const diaFim = pad(lastDay.getUTCDate());
  const mesFim = pad(lastDay.getUTCMonth() + 1);
  const anoFim = lastDay.getUTCFullYear();
  const dataInicioFormatada = `${diaInicio}-${mesInicio}-${anoInicio}`;
  const dataFimFormatada = `${diaFim}-${mesFim}-${anoFim}`;
  const codeUtmsArray = codeUtm ? [codeUtm, perfil].filter(Boolean) : [];
  const codeUtmsArrayTotal = [userUtm, ...(minhasUtms ? Object.values(minhasUtms).flatMap((utmObj) => [utmObj.utm, utmObj.perfil,]) : []),].filter(Boolean);
  function handleLogout() { logout(); Swal.close(); }
  useEffect(() => { if (userData.status === "inativo") { let botaoAtualizarHtml = ""; if (userData.motivoRejeicao.titulo !== "Uso indevido do sistema") { botaoAtualizarHtml = '<a id="atualizar-link" href="/atualizar-dados" style="background: #168a12ff; color: #fff; display: block; text-align: center; padding: 10px; border-radius: 4px; text-decoration: none; width: 100%;">Atualizar dados</a>'; } Swal.fire({ icon: "error", title: userData.motivoRejeicao.titulo, html: `<div>${userData.motivoRejeicao.descricao}</div>` + '<div style="margin-top: 20px;">' + `${botaoAtualizarHtml}` + "</div>", allowOutsideClick: false, allowEscapeKey: false, showCancelButton: false, showConfirmButton: false, backdrop: "rgba(0, 0, 0, 1)", footer: `<div style="display: flex; justify-content: center; align-items: center; gap: 10px; width: 100%;">` + `<button id="logout-btn" style="background: #dc3545; color: #fff; border: none; padding: 10px; border-radius: 4px; width: 100%; cursor: pointer;">Desconectar</button>` + '<a id="chamado-link" href="/abrir-chamado?assunto=inativo" style="background: #0d6efd; color: #fff; display: block; text-align: center; padding: 10px; border-radius: 4px; text-decoration: none; width: 100%;">Abrir chamado</a>' + `</div>`, didOpen: () => { document.getElementById("logout-btn").addEventListener("click", handleLogout); const chamadoLink = document.getElementById("chamado-link"); chamadoLink.addEventListener("click", (event) => { event.preventDefault(); Swal.close(); navigate("/abrir-chamado?assunto=inativo"); }); const atualizarLink = document.getElementById("atualizar-link"); if (atualizarLink) { atualizarLink.addEventListener("click", (event) => { event.preventDefault(); Swal.close(); navigate("/atualizar-dados"); }); } }, }); } }, [userData, handleLogout, navigate]);
  const getUserReceiptYesterday = async () => { try { const response = await api.post("/users/dashboard/receita-ontem", { data: formattedDate, codeUtm: codeUtmsArray.length > 0 ? codeUtmsArray : codeUtmsArrayTotal, }); setReceiptData(response.data); setConvertedValueYesterday(await getDolarCotation(response.data?.receita || 0)); } catch (error) { exibirLogs && console.error("Erro ao buscar valores: ", error); } };
  const getUserReceiptPeriod = async () => { try { const response = await api.post("/users/dashboard/receita-periodo", { dataInicio: dataInicioFormatada, dataFim: dataFimFormatada, codeUtm: codeUtmsArray.length > 0 ? codeUtmsArray : codeUtmsArrayTotal, tipoConta: userData.tipoConta, id: userData._id, }); setReceiptDataPeriod(response.data); setConvertedValuePeriod(await getDolarCotation(response.data?.totalReceita || 0)); setConvertedValueLiquid(await getDolarCotation(response.data?.totalLiquido || 0)); } catch (error) { exibirLogs && console.error("Erro ao buscar valores: ", error); } };
  const getUserReceiptPeriodOnTable = async () => { try { const response = await api.post("/users/dashboard/receita-periodo", { dataInicio: dataInicioFormatadaTable, dataFim: dataFimFormatadaTable, codeUtm: codeUtmsArray.length > 0 ? codeUtmsArray : codeUtmsArrayTotal, tipoConta: userData.tipoConta, id: userData._id, }); setReceiptDataPeriodTable(response.data); } catch (error) { exibirLogs && console.error("Erro ao buscar valores: ", error); } };
  const fetchUltimoUpload = async () => { try { const response = await api.get("/users/dashboard/ultimo-upload"); const data = response.data[0]; const now = Date.now(); const cacheData = { dataConsulta: now, dataInfo: new Date(data.atualizadoEm).getTime(), }; localStorage.setItem(CACHE_KEY, JSON.stringify(cacheData)); setDataInfo(cacheData.dataInfo); } catch (error) { console.error("Erro ao buscar último upload:", error); } };
  useEffect(() => { const cache = localStorage.getItem(CACHE_KEY); if (cache) { const { dataConsulta, dataInfo } = JSON.parse(cache); const agora = Date.now(); if (agora - dataConsulta < CACHE_DURATION_MS) { setDataInfo(dataInfo); return; } else { localStorage.removeItem(CACHE_KEY); } } fetchUltimoUpload(); }, []);
  useEffect(() => { getUserReceiptYesterday(); }, [selectedDate, codeUtm, perfil]);
  useEffect(() => { getUserReceiptPeriod(); }, [selectedDatePeriod, codeUtm, perfil]);
  useEffect(() => { getUserReceiptPeriodOnTable(); }, [selectedStartDate, selectedEndDate, codeUtm, perfil]);
  const showLinks = () => { setModalAberto(true); };
  useEffect(() => { const now = new Date(); const targetDate = new Date(); targetDate.setMonth(now.getMonth() - 2); const month = String(targetDate.getMonth() + 1).padStart(2, "0"); const year = targetDate.getFullYear(); const dateForApi = `${month}/${year}`; async function fetchNotas() { if (!userData?.uid) return; try { const todasAsNotas = await buscarNotasFiscaisPorMes(userData.uid, dateForApi); const notasNormais = todasAsNotas.filter(nota => nota.tipoNota === 'normal'); setNotas(notasNormais || []); } catch (err) { exibirLogs && console.error("Erro ao buscar notas fiscais normais:", err); setNotas([]); } } fetchNotas(); }, [buscarNotasFiscaisPorMes, userData?.uid, exibirLogs]);
  useEffect(() => { const handleResize = () => { setIsMobile(window.innerWidth < 768); }; window.addEventListener("resize", handleResize); return () => window.removeEventListener("resize", handleResize); }, []);
  const changeUtm = (value) => { if (!value.utm) { setCodeUtm(""); setPerfil(""); } else { setCodeUtm(value.utm); setPerfil(value.perfil || ""); } };
  useEffect(() => { if (!userData?._id) { return; } const precisaCadastrarChavePix = !userData.chavesPix || userData.chavesPix.length === 0; const precisaCadastrarRedesSociais = !userData.redesSociais || userData.redesSociais.length === 0; const precisaAceitarTermos = !userData.acceptedTerm; if (precisaCadastrarChavePix) { setModalChavePixAberto(true); } else if (precisaCadastrarRedesSociais) { setModalRedesSociaisAberto(true); } else if (precisaAceitarTermos) { setMostrarComunicado(true); } }, [userData]);
  useEffect(() => { if (userData?.chavesPix && (userData?.tipoConta === "usuario" || userData?.tipoConta === "influenciador")) { const precisaCadastrarDocs = !userData?.documentoFrente || !userData?.documentoVerso; if (precisaCadastrarDocs) { Swal.fire({ icon: "warning", title: "Documentos Pendentes", text: "Para continuar, é necessário que você envie seus documentos para análise.", footer: '<a id="adicionar-documentos-link" href="/atualizar-dados?action=upload" style="background: #0d6efd; color: #fff; display: block; text-align: center; padding: 10px; border-radius: 4px; text-decoration: none; width: 100%;">Adicionar documentos</a>', allowOutsideClick: false, allowEscapeKey: false, showConfirmButton: false, backdrop: "rgba(0, 0, 0, 1)", didOpen: () => { const adicionarDocsLink = document.getElementById("adicionar-documentos-link"); if (adicionarDocsLink) { adicionarDocsLink.addEventListener("click", (event) => { event.preventDefault(); Swal.close(); navigate("/atualizar-dados?action=upload"); }); } }, }); } } }, [userData, navigate]);
  const totalReceitaTable = receiptDataPeriodTable.receitas?.reduce((acc, item) => acc + (item.receita || 0), 0);
  useEffect(() => { const fetchTotalConverted = async () => { const totalConverted = await getDolarCotation(totalReceitaTable || 0); setTotalConverted(totalConverted); }; if (receiptDataPeriodTable?.receitas?.length > 0 || totalReceitaTable === 0) { fetchTotalConverted(); } }, [receiptDataPeriodTable, totalReceitaTable, getDolarCotation]);
  const notaPendente = notas?.find((nota) => nota.status === "pendente");
  const notaCancelada = notas?.find((nota) => nota.status === "cancelado");
  function isCurrentDayBeforeTenth() { const today = new Date(); return today.getDate() < 10; }
  function isCurrentDayFromTenthOnwards() { const today = new Date(); return today.getDate() >= 10; }
  const triggerAlert = useCallback(async (alertData, options = {}) => { if (alertShownRef.current || !alertData) { return; } let alertTitle; let alertText; let formattedNotaDate; if (alertData.status === "nao_enviada") { alertTitle = `Nota de ${alertData.date} não enviada!`; alertText = `Você ainda não emitiu a nota fiscal referente a ${alertData.date}. Por favor, realize a emissão para evitar problemas.`; } else { const nota = alertData; if (nota.date) { if (typeof nota.date === "string" && nota.date.match(/^\d{2}\/\d{4}$/)) { formattedNotaDate = nota.date; } else { const parsedDate = new Date(nota.date); if (!isNaN(parsedDate.getTime())) { formattedNotaDate = format(parsedDate, "MM/yyyy", { locale: ptBR, }); } else { formattedNotaDate = "data inválida"; } } } else { formattedNotaDate = "data desconhecida"; } if (nota.status === "cancelado") { alertTitle = `Nota de ${formattedNotaDate} cancelada!`; alertText = nota.motivoCancelamento || nota.motivoCancelamento !== "" ? nota.motivoCancelamento : `A sua nota fiscal de ${formattedNotaDate} foi cancelada.`; } else if (nota.status === "pendente") { alertTitle = `Nota de ${formattedNotaDate} pendente!`; alertText = `Sua nota fiscal de ${formattedNotaDate} ainda está com o status pendente. Por favor, verifique.`; } else { return; } } alertShownRef.current = true; const swalOptions = { title: alertTitle, text: alertText, icon: "warning", backdrop: "rgba(0, 0, 0, 1)", confirmButtonText: "Resolver Pendência", ...options, }; const result = await Swal.fire(swalOptions); if (result.isConfirmed) { navigate("/emitir-nota-fiscal?tipo=normal"); } }, [navigate]);
  useEffect(() => { if (!Array.isArray(notas)) { return; } const travarAbril = true; if (travarAbril) { const checkDate = new Date(); checkDate.setMonth(checkDate.getMonth() - 2); const targetMonth = checkDate.getMonth(); const targetYear = checkDate.getFullYear(); if (targetMonth === 3 && targetYear === 2025) { exibirLogs && console.log("Exceção de alerta: Período de referência é Abril de 2025. Alertas desativados."); setCanDisplayFiscalAlerts(false); return; } } else { exibirLogs && console.log("Abril não liberado para emissão de nota"); } alertShownRef.current = false; setCanDisplayFiscalAlerts(true); if (isCurrentDayBeforeTenth()) { if (notaCancelada) { triggerAlert(notaCancelada, { allowOutsideClick: true, allowEscapeKey: true, showCancelButton: true, cancelButtonText: "Fechar", }); } } else if (isCurrentDayFromTenthOnwards()) { const nonClosableOptions = { allowOutsideClick: false, allowEscapeKey: false, showCancelButton: false, }; if (notaCancelada) { triggerAlert(notaCancelada, nonClosableOptions); } else { triggerAlert(notaPendente, nonClosableOptions); } } }, [notas, notaCancelada, notaPendente, triggerAlert]);
  const handleSaveRedesSociais = async (redes) => { try { await api.put(`/auth/user/update/${userData._id}`, { redesSociais: redes }); Swal.fire({ icon: "success", title: "Sucesso!", text: "Suas redes sociais foram salvas.", }); setModalRedesSociaisAberto(false); await atualizarDadosUsuario(); } catch (error) { exibirLogs && console.error("Erro ao salvar redes sociais:", error); } };
  const showInfoDolar = () => { Swal.fire({ title: "Cotação do Dólar", text: "Essa cotação do dólar é apenas como referência base em nosso sistema. Considere esta cotação apenas como estimativa. A cotação real será no momento da emissão.", icon: "info", }); };
  const showInfoUpdate = () => { Swal.fire({ title: "Atualização de Dados", html: "Nosso sistema consulta as receitas no Google a cada 10 minutos, porém isso não garante que seus ganhos sejam atualizados nesse intervalo. <br> <br> O Google pode levar mais tempo para processar.", icon: "info", }); };

  return (
    <div className="receitaContainer">
      {/* ... (renderização do JSX) ... */}
      {mostrarComunicado && <ComunicadoAlerta />}
      {canDisplayFiscalAlerts && notaPendente && (
        <Link to={"/emitir-nota-fiscal?tipo=normal"} style={{ textDecoration: "none" }} >
          <Pendente />
        </Link>
      )}
      {dataInfo && (
        <Alert style={{ backgroundColor: "#3C3C3C", color: "#FFF", border: "none" }} >
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", }} >
            <span style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 5, }} >
              <IoIosInformationCircleOutline size={20} onClick={showInfoUpdate} />
              Última atualização:
            </span>
            <span>{new Date(dataInfo).toLocaleString()}</span>
          </div>
        </Alert>
      )}
      {minhasUtms && minhasUtms.length > 0 && (
        <div style={{ marginBottom: 5 }}>
          <strong style={{ color: "#fff" }}>Meus perfis</strong>
        </div>
      )}
      {minhasUtms && minhasUtms.length > 0 && (
        <select className="selectUtm" value={JSON.stringify({ utm: codeUtm, perfil })}
          onChange={(e) => {
            const val = e.target.value;
            try {
              changeUtm(val ? JSON.parse(val) : {});
            } catch (error) {
              console.error("Erro ao converter o valor do select:", error);
              changeUtm({});
            }
          }}
        >
          <option key={userData?.codeUtm} value={JSON.stringify({ utm: userData?.codeUtm, perfil: "" })}>
            {userData?.codeUtm} - Principal
          </option>
          {minhasUtms.map((utm, index) => (
            <option key={index} value={JSON.stringify({ utm: utm.utm, perfil: utm.perfil })}>
              {utm.utm} - {utm.perfil}
            </option>
          ))}
          <option key="total" value={JSON.stringify({ utm: "", perfil: "" })} style={{ fontWeight: 500 }}>
            Todos os perfis
          </option>
        </select>
      )}
      {receiptData ? (
        <>
          <p className="cotationDolar">
            <IoIosInformationCircleOutline size={18} onClick={showInfoDolar} />
            Cotação do dólar: R$ {dolarCotation ? dolarCotation.toFixed(2) : "0.00"}
          </p>
          <div className="card whiteCard">
            <h3 className="cardTitle">Receita por Data</h3>
            <DatePicker selected={selectedDate} onChange={(date) => setSelectedDate(date)} dateFormat="dd/MM/yyyy" locale={ptBR} className="dateInput" placeholderText="Selecione uma data" />
            <br />
            <div className="valueGroup" style={{ marginTop: 0 }}>
              <span className="valueMain green">
                ${receiptData?.receita ? receiptData.receita.toFixed(2) : "0.00"}
              </span>
              <span className="valueSec">
                R$ {convertedValueYesterday || formatarMoeda(0.0)}
              </span>
            </div>
          </div>
        </>
      ) : (
        <div>Carregando...</div>
      )}
      {receiptDataPeriod ? (
        <div className="card whiteCard" style={{ marginTop: 20 }}>
          <h3 className="cardTitle">Receita por Mês</h3>
          <DatePicker selected={selectedDatePeriod} onChange={(date) => setSelectedDatePeriod(date)} dateFormat="MM/yyyy" className="dateInput" showMonthYearPicker showFullMonthYearPicker />
          <br />
          <div className="infoBlock">
            <p className="infoTitle">
              Total de receita em:{" "}
              {mesAtual.charAt(0).toUpperCase() + mesAtual.slice(1)}
            </p>
            <div className="valueGroup">
              <span className="valueMain green">
                $
                {receiptDataPeriod?.totalReceita
                  ? receiptDataPeriod.totalReceita.toFixed(2)
                  : "0.00"}
              </span>
              <span className="valueSec">
                R$ {convertedValuePeriod || formatarMoeda(0.0)}
              </span>
            </div>
          </div>
          {userData.tipoConta !== "administrador" && (
            <div className="infoBlock">
              <p className="infoTitle">
                Receita Líquida em:{" "}
                {mesAtual.charAt(0).toUpperCase() + mesAtual.slice(1)}
              </p>
              <div className="valueGroup">
                <span className="valueMain green">
                  $
                  {receiptDataPeriod?.totalLiquido
                    ? receiptDataPeriod.totalLiquido.toFixed(2)
                    : "0.00"}
                </span>
                <span className="valueSec">
                  R$ {convertedValueLiquid || formatarMoeda(0.0)}
                </span>
              </div>
            </div>
          )}
        </div>
      ) : (
        <div>Carregando...</div>
      )}
      <div className="listUtms">
        <div style={{ marginBottom: 15, color: "#fff" }}>
          <strong>
            Receitas por Link (
            {codeUtm || perfil
              ? `${codeUtm}${perfil ? " - " + perfil : ""}`
              : "Todos"}
            )
          </strong>
        </div>
        <div style={{ marginBottom: 20 }}>
          <button
            className="dateInput"
            onClick={() => setMostrarCalendario(true)}
            style={{
              width: "fit-content",
              display: "flex",
              alignItems: "center",
              gap: 5,
            }}
          >
            <FaRegCalendarAlt size={18} />
            {`${format(selectedStartDate, "dd/MM/yyyy")} - ${format(
              selectedEndDate,
              "dd/MM/yyyy"
            )}`}
          </button>
        </div>
        {mostrarCalendario && (
          <div className="overlayCalendar">
            <>
              <DateRange
                editableDateInputs={true}
                locale={ptBR}
                onChange={(item) => {
                  const startDate = new Date(item.selection.startDate.getFullYear(), item.selection.startDate.getMonth(), item.selection.startDate.getDate());
                  const endDate = new Date(item.selection.endDate.getFullYear(), item.selection.endDate.getMonth(), item.selection.endDate.getDate());
                  setSelectedStartDate(startDate);
                  setSelectedEndDate(endDate);
                  setPeriodTable([item.selection]);
                }}
                moveRangeOnFirstSelection={false}
                ranges={periodTable}
              />
              <button
                className="btnFecharCalendario"
                onClick={() => setMostrarCalendario(false)}
              >
                Confirmar
              </button>
            </>
          </div>
        )}
        <div
          style={{
            marginBottom: 10,
            padding: 8,
            backgroundColor: "#fff",
            borderRadius: 10,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: 2,
            flexDirection: "column",
          }}
        >
          <strong style={{ fontSize: 27, fontWeight: "bold", color: "#00A500", }} >
            $ {formatarMoedaDolar(totalReceitaTable)}{" "}
            <span style={{ fontSize: 14, color: "black" }}>
              R$ {totalConverted}
            </span>
          </strong>
          <span style={{ fontSize: 15, color: "#888" }}>
            Total de receita
          </span>
        </div>
        <Table striped className="table-dark" responsive style={{ tableLayout: "auto" }} >
          <thead>
            <tr>
              <th>Link</th>
              <th>Impressões</th>
              <th>Receita</th>
              <th>RPM</th>
            </tr>
          </thead>
          <tbody>
            {receiptDataPeriodTable &&
            receiptDataPeriodTable?.receitas?.length === 0 ? (
              <></>
            ) : (
              receiptDataPeriodTable?.receitas
                ?.sort((a, b) => b.impressoes - a.impressoes)
                .map((data, index) => {
                  const rpm = (data.receita / data.impressoes) * 1000;
                  return (
                    <tr key={index}>
                      <td>
                        <span>{data.utmCampaign}</span>
                      </td>
                      <td>{data.impressoes}</td>
                      <td>
                        ${data.receita ? data.receita.toFixed(2) : "0.00"}
                      </td>
                      <td>${rpm > 0 ? rpm.toFixed(2) : "0.00"}</td>
                    </tr>
                  );
                })
            )}
          </tbody>
        </Table>
      </div>
      {codeUtmsArray.length > 0 && (
        <button className="btnLinks" onClick={showLinks}>
          Meus links
        </button>
      )}
      <AlertModal
        isOpen={isAlertModalOpen}
        alerta={alertaPendente}
        onRespond={handleUserResponseToAlert}
        foiRecusado={alertaRecusado}
      />
      <ModalLinks
        isOpen={modalAberto}
        toggle={() => setModalAberto(!modalAberto)}
        userUtm={codeUtm}
      />
      <ModalChavesPix
        isOpen={modalChavePixAberto}
        onClose={() => setModalChavePixAberto(false)}
      />
      <ModalRedesSociais
        isOpen={modalRedesSociaisAberto}
        onClose={() => setModalRedesSociaisAberto(false)}
        onSave={handleSaveRedesSociais}
      />
    </div>
  );
}

export default UserDashboard;